import classNames from 'classnames';
import Link from 'next/link';
import Image from 'next/image';
import { useSanitizedTranslation } from 'ui';

export const ButtonRow = ({ buttons }) => {
  return (
    <div className="align-start flex justify-start space-x-8">
      {buttons.map(button => (
        <XumoButton {...button} />
      ))}
    </div>
  );
};

export const XumoButton = ({ submit, children, light, href, onClick, label, target, disabled, alignment, secondary, primary, color, className }) => {
  const style = 
  light 
    ? `${primary ? 'border-white bg-white text-black' : secondary ? 'bg-transparent text-white border-white' : 'bg-white text-black'}` 
    : `${primary ? 'border-black bg-black text-white' : secondary ? 'bg-transparent text-black border-black' : 'bg-black text-white'}`;
  const addAlignment = alignment ? alignment : 'self-center';
  const { t } = useSanitizedTranslation();

  const classes = classNames(
    'btn',
    'cursor-pointer',
    'rounded-md',
    'border-2',
    'border-black',
    'text-[16px]',
    'weight-600',
    style,
    addAlignment,
    'outline',
    'outline-2',
    'outline-offset-2',
    'outline-transparent',
    color ? `hover:outline-${color}` : 'hover:outline-xumoTeal',
    'transition-colors',
    'px-8',
    'py-4',
    'inline-block',
    'whitespace-nowrap',
    'disabled:bg-xumoOnyx disabled:text-xumoCharcoal',
    className
  );

  return submit ? (
    <button data-i18n={label || children} onClick={onClick} className={classes} disabled={disabled}>
      {t(label) || t(children)}
    </button>
  ) : (
    <Link data-i18n={label || children} onClick={onClick} href={href || ''} className={classes} target={target} disabled={disabled}>
      {t(label) || t(children)}
    </Link>
  );
};

export const ImageButton = ({ children, image, hoverImage, href, onClick, label, target, disabled }) => {
  const classes = classNames('btn', 'cursor-pointer', 'inline-block', 'whitespace-nowrap');

  return (
    <Link onClick={onClick} href={href || ''} className={classes} aria-label={label}>
      <Image {...image} />
    </Link>
  );
};